import React from 'react'
import './ConfirmationPopup.css'
function ConfirmationPopup(props) {

    return (
        <div className='ConfirmationPopup'>
              <div className='ConfirmationPopup-overlay' onClick={()=>props.onClose()}/>
            
                <div className='Confirm-Body'>
                    <div className='Cross-div'>
                        <img src='/assets/CrossPopup.png' className='Cross'  onClick={()=>props.onClose()}/>
                    </div>
                    <div className='Confirm-inner-body'>

                        <p className='heading'>Confirmation</p>

                        <div className='Confirm-card-container'>
                            <div className='Confirm-card-inputcontainer'>
                                <div className='Confirm-inputcontainer-div'>
                                    <input placeholder='0.0' disabled value={props.value}/>
                                    <p>{props.swap?'$GDBX':'$EGBX'}</p>
                                </div>

                            </div>
                            <div className='Confirm-card-inputcontainer'>
                                <div className='Confirm-inputcontainer-div'>
                                    <input placeholder='0.0' disabled value={props.convertedValue.toFixed(6)}/>
                                    <p>{props.swap?'$EGBX':'$GDBX'}</p>
                                </div>
                            </div>
                            <div className='Confirm-swapbutton' >
                                <img src='/assets/swapArrow.png' className='Confirm-swaparrow' />
                            </div>

                        </div>
                        <p className='Confirm-subtext'>{props.amount}</p>
                        <div className='Confirm-card-container'>
                            <div className='Confirm-card-textcontainer'>
                                <div className='Confirm-textcontainer-div'>
                                    <p>Expected Output</p>
                                    <p style={{textAlign:'left'}}>{props.minAmount.toFixed(6)} {!props.swap?'$GDBX':'$EGBX'}</p>
                                </div>
                                <div className='Confirm-textcontainer-div'>
                                    <p>Price Impact</p>
                                    <p style={{textAlign:'right'}}>{props.impact}</p>
                                </div>
                            </div>
                        </div>
                        <p className='Confirm-subtext'>Output is estimated. You will receive at least <span style={{ fontFamily: 'Semi-bold' }}>{props.minAmount.toFixed(6)}</span> {!props.swap?'$GDBX':'$EGBX'} or the transaction will revert.</p>
                        <button className='Confirm-btn' disabled={props.loader} onClick={()=>props.onSwap()}>
                           {props.loader?'Swapping':'Confirm'}
                        </button>
                    </div>
                </div>
         
        </div>
    )
}

export default ConfirmationPopup